import { Button, Input, Loader, Table } from '@scuf/common';
import moment from 'moment';
import i18next from '../../../i18next';
import { SplitPanelUtil } from '../../commonUtils/SplitPanelUtil';
import './FillPartnerDetails.scss';
import {
  EMPTY_GUID,
  IAssociatedResources,
  ISubscriptionList
} from './SKULIst/SKUModels';

interface IFillPartnerDetailsProps {
  panelSelectedRow: ISubscriptionList;
  associatedResourcesCount: number;
  handleChange: (event: any, type: string) => void;
  associatedResources?: IAssociatedResources;
  activatingSubscription: boolean;
  activatedOn: string;
}

export const FillPartnerDetails = (props: IFillPartnerDetailsProps) => {
  const rowData = (heading: string, value: string) => {   
    return (
      <Table.Row className="custom-table-row">
        <Table.Cell className="custom-heading-width">
          {i18next.t(heading)}
        </Table.Cell>
        <Table.Cell>{value}</Table.Cell>
      </Table.Row>
    );
  };
  const linkData = (content: string, linkText: string) => {
    return (
      <div className="others-content">
        {i18next.t(content)}&nbsp;
        <a className="link" href="mailto:support@honeywell.com" type="link">
          {i18next.t(linkText)}
        </a>
      </div>
    );
  };

  const getSKUStatus = () => {
    if (
      props.panelSelectedRow.subscriptionId === '' ||
      props.panelSelectedRow.subscriptionId === EMPTY_GUID
    ) {
      return rowData('status', i18next.t('pendingActivation'));
    } else if (
        props.associatedResourcesCount > 0 &&
        props.associatedResourcesCount <=
          props.panelSelectedRow.totalQuantity &&
        (props.activatedOn === null || (new Date(props.activatedOn || 0).getFullYear() === 1))
      ) {
        return (
          <Table.Row className="custom-table-row">
            <Table.Cell className="custom-heading-width">
              {i18next.t('status')}
            </Table.Cell>
            <Table.Cell>
              <Button
                className="link"
                type="link"
                disabled={props.activatingSubscription}
                onClick={e => props.handleChange(e, 'ActivateSubscription')}
              >
                {i18next.t('activateNow')}
              </Button>
            </Table.Cell>
          </Table.Row>
        );
      }
      else if (props.activatedOn)
      {
          return rowData('status', i18next.t('activated'))
      }
      else {
        //do nothing
      }
  };

  return (
    <div>
      <SplitPanelUtil>
        <SplitPanelUtil.Table>
          <Table className="custom-table">
            {rowData('skuName', props.panelSelectedRow.skuName)}
            {rowData('skuDescription', props.panelSelectedRow.skuDescription)}
            {rowData(
              'licenseUtilization',
              props.panelSelectedRow.utilizedQuantity +
                ' / ' +
                props.panelSelectedRow.totalQuantity +
                ' ' +
                i18next.t('utilized')
            )}
            {rowData(
              'validTill',
              moment(props.panelSelectedRow.validTill).format(
                'DD/MM/YYYY hh:mm A'
              )
            )}
            {getSKUStatus()}
          </Table>
        </SplitPanelUtil.Table>
      </SplitPanelUtil>

      <div className="fill-partner-details-modal">
        <Input
          label={i18next.t('associatedSubscriptionNumber')}
          type="subsno"
          className="inputBox"
          disabled={true}
          value={props.panelSelectedRow.subscriptionNumber}
        />
        {linkData('helperTextSKU', 'customerCare')}
        <Input
          label={i18next.t('associatedOrderNumber')}
          type="ordno"
          className="inputBox"
          disabled={true}
          value={props.panelSelectedRow.orderNumber}
        />
        {linkData('helperOrderTextSKU', 'customerCare')}
      </div>
      {props.activatingSubscription && <Loader text={i18next.t('loading')} overlayOpacity={0.5} />}
    </div>
  );
};

export default FillPartnerDetails;